import React from 'react';
import * as MUI from '@material-ui/core';
import { useStylesLargePopover, useStylesPopover } from './styles';

export default ({ children, anchorEl, large, ...props }) => {
  const open = Boolean(anchorEl);

  return (
    <MUI.Popover
      {...props}
      open={open}
      anchorEl={anchorEl}
      classes={large ? useStylesLargePopover(props) : useStylesPopover(props)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {children}
    </MUI.Popover>
  );
}